export default {
  likes: { name: 'curtidas' },
  shares: { name: 'compartilhamentos' },
  comments: { name: 'comentários' },
  videoplays: { name: 'visualizações' },
  followers: { name: 'seguidores' },
  unknown: { name: 'desconhecido' },
};
